import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=041f7b57&scoped=true&"
import script from "./TagSelect.vue?vue&type=script&lang=ts&"
export * from "./TagSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=041f7b57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f7b57",
  null
  
)

export default component.exports